export default {
  name: "callback",
  props: ["auth"],
  created() {
    this.$props.auth.handleAuth0();
  }
};
